import React from 'react'
import SliderBasicItemWrapper from './SliderBasicItemWrapper'
import SliderBasicTitle from './SliderBasicTitle'
import SliderBasicDescription from './SliderBasicDescription'
import SliderBasicLinkButton from './SliderBasicLinkButton'
import getBackgroundAdObj from '../functions/getBackgroundAdObj'
import SandwichElementTitle from './SandwichElementTitle'


const SliderBasicItemAd = ({ 
    adData,
    oddSlide, 
    kenBurnsToggle, 
    isJustOneItem, 
    className, 
    backgroundVisualsSettings, 
    autoplaySpeed, 
    translation, 
    canParallax,
    isMobile,
    sliderTitle 
}) => {
          
    const { title, text, link, imagePoster, position, cinema} = adData
    const linkText = link ? link.text : null
    const destinationType = link ? link.destinationType : null
    const linkUrl = link ? link.url : null
    const backgroundAd = getBackgroundAdObj(imagePoster, position)
    const el = document.getElementsByClassName("slick-dots " + className)
    let marginBottom = 40

    if(el[0]) {
        marginBottom = el[0].clientHeight + 10
    }

    const styles = {
        marginBottom:  marginBottom
    }
    
    return (
        <SliderBasicItemWrapper
            oddSlide={oddSlide}
            isMobile={isMobile}
            cinemas={[cinema]}
            kenBurnsToggle={kenBurnsToggle}
            isJustOneItem={isJustOneItem}
            className={className + ' own-content'}
            backgroundVisualsSettings={backgroundVisualsSettings}
            autoplaySpeed={autoplaySpeed}
            backgroundImage={backgroundAd}
            canParallax={canParallax}
            translation={translation}
        >
            {sliderTitle && <SandwichElementTitle title={sliderTitle} cinemas={[cinema]}/>}
            
            <div className='slide-item-content-wrapper'>
                <div className="slider-item-text">
                    <SliderBasicTitle title={title}/>
                    <SliderBasicDescription description={text} /> 
                </div>

                <div className="slider-item-link" style={styles}>
                    {linkUrl && linkText && destinationType && (
                        destinationType === 'external' ? (
                            <a className="button-text" target={"_blank"} href={linkUrl}>
                                <SliderBasicLinkButton linkText = {linkText} cinemas={[cinema]} className={className}/>
                            </a>
                        ) : (
                            <a className="button-text" href={linkUrl}>
                                <SliderBasicLinkButton linkText = {linkText} cinemas={[cinema]} className={className}/>
                            </a>
                        ))
                    }
                </div>
            </div>
        </SliderBasicItemWrapper>
    )
}

export default SliderBasicItemAd